

// Require

const { id, log, vh, min, limit } = require("../std/index")

const { Slice } = require("./master")


//
// "Which Casing" Slice
//

module.exports = class SpecialsSlice extends Slice {
  constructor($host, config) {
    super($host, config);
    this.dom.layout = $('[data-layout]', $host);
    this.dom.linkList = $('.link-list', $host);
    this.dom.specials = $('.specials', $host);
    this.dom.video = $('.backdrop', $host);
  }

  onProgress(p) {
    const offset = 0;
    const low = 0;
    const clamp = limit(0, 1);

    const p1 = clamp(p);
    const p2 = clamp(p - 1);
    const p3 = clamp(p - 2);
    const v1 = 1 - p1;

    const dest = this.dom.specials[0].offsetHeight - vh(low);

    //TweenMax.set(this.dom.linkList, { marginTop: offset + v1 * vh(low) });
    //TweenMax.set(this.dom.linkList, { y: p3 * vh(100) });
    //TweenMax.set(this.dom.specials, { marginTop: offset + v1 * vh(low) });
    //TweenMax.set(this.dom.specials, { y: min(0, p2 * -dest) });

    //TweenMax.to(this.dom.video, 0.1, { y: Math.min(900, document.body.scrollTop/2) });
  }
};
